import { ApiClient } from '@dozuki/web-js/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { useLocalization } from '~/framework';
import { getUser, getUserFromClient, GetUserErrorCode } from '~/pages/api/users';
import { useApiErrorMessageToast } from '~/pages/_shared';

const KEY = 'user';

export function useUser(userid: number | null) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast<GetUserErrorCode>({
      'users.user_not_found': _js('Could not find selected user'),
      default: _js('There was a problem retrieving the selected user; please try again'),
   });

   const queryFunction = async () => {
      if (userid === null) return null;
      return await getUserFromClient(userid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: [KEY, userid],
      onError: handleErrorOrRedirectToLogin,
   });
}

export async function prefetchUser(
   userid: number,
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.fetchQuery([KEY, userid], () => getUser(userid, { apiClient }));
}
